require('./creditHeader.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @helpers
const { getFinalTitle } = require('core/i18n').i18n;

//@constants
const {
    LOANS_MORTGAGES_PREGRANTED_CREDIT,
    LOANS_MORTGAGES_INVESTMENT_CREDIT
} = require('constants/index');
// @ Loans
const { okLoansComponents } = require('ok-loans');
//@components
const CreditHeaderBar = require('components/credits/creditHeaderBar/creditHeaderBar');
const LoansCreditsMoreOptionsButton = okLoansComponents.loansCreditsMoreOptionsButton;

const CREDIT_TYPES = [
    LOANS_MORTGAGES_PREGRANTED_CREDIT,
    LOANS_MORTGAGES_INVESTMENT_CREDIT
];

class CreditHeader extends React.Component {
    constructor(props) {
        super(props);

        this.resize = this.resize.bind(this);

        this.state = {
            parentWidth: window.innerWidth
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    getCreditType(immCredit) {
        const type = immCredit.get('type');
        const validType = CREDIT_TYPES.indexOf(type) !== -1;
        if (type && validType) {
            return type;
        } else {
            return LOANS_MORTGAGES_PREGRANTED_CREDIT;
        }
    }

    resize() {
        this.setState({
            parentWidth: window.innerWidth
        });
    }

    render() {
        const { titleKey, breadcrumbConfig, immCredit } = this.props;
        const creditType = this.getCreditType(immCredit);

        return (
            <article className="credit-header">
                <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumbConfig}
                        hasTitle={this.state.parentWidth > 1024}
                        finalTitle={getFinalTitle(titleKey)}>
                        <CreditHeaderBar immCredit={immCredit} />
                        <LoansCreditsMoreOptionsButton
                            id={immCredit.get('id')}
                            type={creditType}
                        />
                    </OKHeaderSubPage>
                </OKCover>
            </article>
        );
    }
}

CreditHeader.propTypes = {
    titleKey: PropTypes.string,
    breadcrumbConfig: PropTypes.array,
    immCredit: PropTypes.object.isRequired
};

module.exports = CreditHeader;
